import { axiosDS } from '@pp/axios'
import { ResponseCatalog, RequestParams, CertificateModel } from 'Models'
import { SimpleResponse } from 'Types/simpleResponse'

import { urls } from 'Constants/Urls'
import { RbidosAccessModel, RbidosAccessAgentModel } from 'Pages/registry_business_access_neo'

export const rbidosAccessApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<RbidosAccessModel>>(urls.rbidos_access.base, {
			params,
		})
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<RbidosAccessModel>(`${urls.rbidos_access.base}/${id}`)
		return res.data
	},
	createOne: async (id: number, infotecs_type: string) => {
		const res = await axiosDS().post<RbidosAccessModel>(urls.rbidos_access.base, {
			partner_id: id,
			data: {
				infotecs_type,
			},
		})
		return res.data
	},
	updateOne: async (id: number, data: RbidosAccessModel) => {
		const res = await axiosDS().patch<RbidosAccessModel>(`${urls.rbidos_access.base}/${id}`, {
			data,
		})
		return res.data
	},
	getNewAgent: async (id: string) => {
		const res = await axiosDS().get<RbidosAccessAgentModel>(
			`${urls.rbidos_access.base}/${id}/agents/new`
		)
		return res.data
	},

	statusChange: async (id: number, status: string, message?: string) => {
		const res = await axiosDS().patch(`${urls.rbidos_access.base}/${id}/action`, {
			data: { status, message },
		})
		return res.data
	},
	signDocument: async (
		id: number,
		document_id: number,
		signature: string,
		certificate_info?: CertificateModel
	) => {
		const res = await axiosDS().patch<SimpleResponse>(
			urls.rbidos_access.sign
				.replace(':infotecs_request_id', String(id))
				.replace(':id', String(document_id)),
			{
				data: { signature, certificate_info },
			}
		)
		return res.data
	},
	sendSignature: async (id: number) => {
		const res = await axiosDS().put<SimpleResponse>(
			urls.rbidos_access.send_signature.replace(':id', String(id))
		)
		return res.data
	},
	synchronize: async (id: number) => {
		const res = await axiosDS().put(`${urls.rbidos_access.base}/${id}/synchronize`)
		return res.data
	},
	checkInfotecsStatus: async (id: number) => {
		const res = await axiosDS().patch(`${urls.rbidos_access.base}/${id}/check_status`)
		return res.data
	},
}
